export default __webpack_public_path__ + "static/media/small.e0b8e8a0.jpg";